import axios from 'axios';
import URLS from "../../util/urls.js"

const state = {
  form: {
    id: 0,
    nome: undefined,
    cidade: {
      estado: undefined
    },
    variacoesNome: []
  },

  formPesquisa: {
    nome: '',
    cidade: {
      estado: {
        id: undefined
      }
    },
  },

  quantidadeBairros: 0,

  bairros: [],
  cidadesDisponiveis: []
}

const mutations = {
  atualizarCidadesDisponiveis(state, payload) {
    state.cidadesDisponiveis = payload;
  },

  atualizarBairros(state, payload) {
    state.bairros = payload;
  },

  atualizarBairroSelecionado(state, payload) {
    state.form.id = payload.id
    state.form.nome = payload.nome
    state.form.cidade = payload.cidade
    state.cidadesDisponiveis = [payload.cidade]
    state.form.variacoesNome = payload.variacoesNome
  },

  limparForm(state) {
    state.form = {
      id: 0,
      nome: '',
      cidade: {
        estado: 0
      },
      variacoesNome: []
    }
  },

  limparFormPesquisa(state) {
    state.formPesquisa = {
      nome: '',
      cidade: {
        estado: {
          id: undefined
        }
      },
    }
  },

  setQuantidadeBairros(state, payload) {
    state.quantidadeBairros = payload
  }
}

const actions = {
  limparForm(context) {
    context.commit('limparForm')
  },

  limparFormPesquisa(context) {
    context.commit('limparFormPesquisa')
  },

  listarBairros(context, payload) {
    return axios.post(URLS.BAIRROS_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarBairros', response.data.lista);
          context.commit('setQuantidadeBairros', response.data.quantidade)
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, {root: true})
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('listarBairros', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  recuperarBairro(context, payload) {
    return axios.post(URLS.BAIRROS_RECUPERAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarBairroSelecionado', response.data);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarBairro', payload);
            } 
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarBairroSelecionado', response.data);
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarBairro(context, payload) {
    return axios.post(URLS.BAIRROS_GRAVAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarBairroSelecionado', response.data.item);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarBairro', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
            context.commit('atualizarBairroSelecionado', response.data.item);
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  removerBairro(context, payload) {
    return axios.post(URLS.BAIRROS_REMOVER, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('removerBairro');
            }
          }).catch(error => {
            throw error;
          });
        default:
          if(response.data.status !== 'FALHA') {  
            context.commit('limparForm')
          }
  
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  gravarVariacoesNome(context, payload) {
    return axios.post(URLS.BAIRROS_GRAVAR_VARIACAO, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, {root: true})
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gravarVariacoesNome', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          context.commit('atualizarBairroSelecionado', response.data.item)
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  },

  recuperarCidades(context, payload) {
    return axios.post(URLS.CIDADES_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          context.commit('atualizarCidadesDisponiveis', response.data.lista);
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('recuperarCidades', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
}

export default {
  state,
  mutations,
  actions
}